import { PowerSettingsNew } from '@mui/icons-material'
import { Box } from '@mui/material'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import * as S from './styles'
import { logout } from '~/store/user/middlewares'

interface LogoutProps {
  drawerOpen: boolean
}

export const Logout = ({ drawerOpen }: LogoutProps) => {
  const dispatch = useDispatch()

  const navigate = useNavigate()

  const onSignOut = () => {
    dispatch(logout())
    navigate('/')
  }

  return (
    <Box mt="auto">
      <Box border="1px solid #EBEBEF" />
      <S.LogoutButton onClick={onSignOut}>
        <PowerSettingsNew />

        {drawerOpen && (
          <Box fontWeight="400" ml="11px">
            Logout
          </Box>
        )}
      </S.LogoutButton>
    </Box>
  )
}
